import React, { useRef } from 'react';
import { SVGAssets } from '@business/assets/vectors';
import { Button } from '../Button';

export interface SearchInputProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onClear?: () => void;
  placeholder?: string;
  className?: string;
  inputClassName?: string;
  onCameraClick?: () => void;
  isFromMultiDropdown?: boolean;
  isLoading?: boolean;
}

export const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onKeyDown,
  onClear,
  placeholder = 'Search...',
  className = '',
  inputClassName = '',
  onCameraClick,
  isFromMultiDropdown = true,
  isLoading
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  return (
    <div className={` border-gray-200 ${className}`}>
      <div className="relative">
        {/* Search Icon - Start Decorator */}
        <div className="absolute left-3 top-1/2 transform -translate-y-1/2 pointer-events-none">
          <SVGAssets.Search className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400" />
        </div>

        <input
          ref={inputRef}
          type="text"
          value={value}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={placeholder}
          className={`w-full pl-10 sm:pl-11 pr-10 sm:pr-11 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-2xl focus:outline-none focus:ring-0 focus:border-gray-300 ${inputClassName}`}
        />
        {isLoading && (
          <div className="absolute right-11 top-1/2 transform -translate-y-1/2">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-[#7F9D48]" />
          </div>
        )}
        {/* Clear/Camera Icon - End Decorator */}
        {value && onClear ? (
          <button
            type="button"
            onClick={onClear}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
            aria-label="Clear search">
            <SVGAssets.CloseIconGray className="w-4 h-4 sm:w-5 sm:h-5" />
          </button>
        ) : (
          <>
            {!isFromMultiDropdown && (
              <Button
                btnStyle="link"
                onClick={onCameraClick}
                className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 cursor-pointer"
                aria-label="Camera">
                <SVGAssets.TakePicIcon className="w-4 h-4 sm:w-5 sm:h-5" />
              </Button>
            )}
          </>
        )}
      </div>
    </div>
  );
};
